import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Draggable from 'react-draggable';
import PropTypes from 'prop-types';

import Frame from './frame';

import usePortal from '../../helpers/usePortal';
import useWindowSize from '../../helpers/useWindowSize';
import { toggleGuidesPortal } from '../../../../redux/actions/general';

const Guides = ({ guidesFrameRef }) => {
  const toggleBtnRef = useRef(null);

  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [frameParams, setFrameParams] = useState({});

  const windowSize = useWindowSize();
  const dispatch = useDispatch();

  const onClosePortal = () => {
    setFrameParams({});
    dispatch(toggleGuidesPortal(false));
  };

  const { guidesPortal, guidesParams } = useSelector((state) => state.general);
  const { openPortal, closePortal, isOpen, Portal } = usePortal({ portalStyles: null, onClose: onClosePortal });

  const onTogglePopover = (event) => {
    event.preventDefault();
    if (isOpen) {
      closePortal(event);
      dispatch(toggleGuidesPortal(false));
    } else {
      openPortal(event);
      dispatch(toggleGuidesPortal(true));
    }
  };

  const onDragStop = (data) => {
    const { x, y } = data;
    setPosition({ x, y });
  };

  useEffect(() => {
    if (windowSize?.width < 370) {
      setPosition({ x: 0, y: 0 });
    }
  }, [windowSize.width]);

  useEffect(() => {
    if (!isOpen && guidesPortal) {
      setFrameParams(guidesParams);
      openPortal({ currentTarget: toggleBtnRef.current });
    }
    if (isOpen && guidesPortal) {
      guidesFrameRef?.current?.sendMessage(guidesParams);
    }
    if (isOpen && !guidesPortal) {
      setFrameParams({});
      dispatch(toggleGuidesPortal(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [guidesPortal, guidesParams]);

  useEffect(
    () => () => {
      setFrameParams({});
      closePortal({ currentTarget: toggleBtnRef.current });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return (
    <>
      <a
        ref={toggleBtnRef}
        onClick={onTogglePopover}
        href="# "
        role="button"
        className={`nav__link nav__link-icon navbar-popover__toggle${isOpen ? ' opened' : ''}`}
      >
        <i className="fas fa-question-circle nav-icon" />
      </a>

      {isOpen && (
        <Portal>
          <Draggable disabled={windowSize.width < 370} handle=".handle" defaultPosition={position} onStop={(_, data) => onDragStop(data)}>
            <div className="navbar-popover navbar-popover__guides">
              <div className="navbar-popover__header handle">
                <div className="title">
                  <span>Help center</span>
                </div>
                <button type="button" className="close" onClick={closePortal} onTouchEnd={closePortal}>
                  <span aria-hidden="true">×</span>
                  <span className="sr-only">Close</span>
                </button>
              </div>

              <Frame ref={guidesFrameRef} params={frameParams} />
            </div>
          </Draggable>
        </Portal>
      )}
    </>
  );
};

Guides.propTypes = {
  guidesFrameRef: PropTypes.object,
};

export default Guides;
